
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/statsig",
      function () {
        return require("private-next-pages/destinations/statsig.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/statsig"])
      });
    }
  